import { render, staticRenderFns } from "./station-fee-details.vue?vue&type=template&id=009f0d9b&scoped=true&"
import script from "./station-fee-details.vue?vue&type=script&lang=js&"
export * from "./station-fee-details.vue?vue&type=script&lang=js&"
import style0 from "./station-fee-details.vue?vue&type=style&index=0&id=009f0d9b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009f0d9b",
  null
  
)

export default component.exports